import type { ApplicationAliases } from "./ApplicationAliases";

export abstract class Application {
    private static bound = new Map<keyof ApplicationAliases, unknown>();

    /**
     * Bind an object to the application container.
     *
     * If concrete is not specified, the abstract class will be initialised with no arguments
     */
    public static bind<K extends keyof ApplicationAliases>(
        alias: K,
        concrete: ApplicationAliases[K]
    ): void {
        if(this.bound.has(alias)) {
            throw new Error(`Cannot bind ${alias} to ${concrete.constructor.name} as it is already bound`);
        }

        this.bound.set(alias, concrete);
    }

    /**
     * Retrieve a previously bound object by using its alias
     */
    public static get<K extends keyof ApplicationAliases>(alias: K): ApplicationAliases[K] {
        const concrete = this.bound.get(alias);

        if(typeof concrete === "undefined") {
            throw new Error(`Cannot get ${alias} as it is not bound`);
        }

        return concrete as ApplicationAliases[K];
    }
}
